import React from 'react'

import {
  Box,
  Color,
  Display,
  DisplayPosition,
  FlexDirection,
  FontWeight,
  Text,
} from '@gousto-internal/citrus-react'
import type { CompactCampaignBannerRecipeItem } from '@library/api-menu-experience'
import { TileImage as RecipeTileImage } from '../../RecipeGrid/RecipeTileImage/TileImage'

import {
  CardTextFlow,
  MerchandisingBasketButton,
  MerchandisingRecipeBannerTagStrip,
  MerchandisingRecipeSurcharge,
  type MerchandisingRecipeCardProps,
  twoLineTitleClampStyle,
} from './campaignBannerCard.atoms'

export type CompactCampaignBannerRecipeCardProps =
  MerchandisingRecipeCardProps<CompactCampaignBannerRecipeItem>

export const CompactCampaignBannerRecipeCard = ({
  recipe,
  onClick,
  onAddClick,
  onRemoveClick,
  onBlockedAddAttempt,
  canAddRecipes,
  reachedLimit,
  isInBasket,
  isOutOfStock,
  index,
}: CompactCampaignBannerRecipeCardProps) => {
  const handleClick = () => onClick(recipe.id)
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleClick()
    }
  }

  return (
    <Box
      data-testid="compact-campaign-banner-recipe-card"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      bg={Color.White}
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      flexShrink={0}
      width={['180px', '220px']}
      style={{
        borderRadius: '4px',
        boxShadow: '0 8px 10px -8px rgba(19, 35, 53, 0.18)',
        cursor: 'pointer',
        overflow: 'hidden',
      }}
    >
      <Box
        position={DisplayPosition.Relative}
        style={{
          height: '140px',
          overflow: 'hidden',
        }}
      >
        <RecipeTileImage
          lazy={false}
          recipe={{
            images: [
              {
                type: 'image',
                ...recipe.image,
              },
            ],
            name: recipe.title,
          }}
          insideOverflow
          testId="compact-campaign-banner-recipe-card-image"
        />
      </Box>
      <Box
        bg={Color.White}
        paddingH={3}
        paddingBottom={3}
        style={{
          flex: 1,
          marginTop: -2,
          minHeight: '88px',
          position: 'relative',
        }}
      >
        <MerchandisingBasketButton
          recipeId={recipe.id}
          isInBasket={isInBasket}
          isOutOfStock={isOutOfStock}
          canAddRecipes={canAddRecipes}
          reachedLimit={reachedLimit}
          onAddClick={onAddClick}
          onRemoveClick={onRemoveClick}
          onBlockedAddAttempt={onBlockedAddAttempt}
          index={index}
        />
        <CardTextFlow style={{ paddingTop: '8px' }}>
          <Text
            color={Color.ColdGrey_900}
            fontWeight={FontWeight.Bold}
            size={2}
            style={twoLineTitleClampStyle}
          >
            {recipe.title}
          </Text>
        </CardTextFlow>
        <MerchandisingRecipeSurcharge pricing={recipe.pricing} isOutOfStock={isOutOfStock} />
      </Box>
      <MerchandisingRecipeBannerTagStrip banner={recipe.tagGroups?.banner} />
    </Box>
  )
}
